<template>
    <div v-loading="isLoading" class="user-groups">
        <table>
            <thead>
                <tr>
                    <th>USER GROUP</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(userGroup, userGroupIndex) in userGroupList" :key="userGroupIndex">
                    <td class="title">
                        <span @click="openEditUserGroup(userGroup)">{{ userGroup.name }}</span>
                    </td>

                    <td style="width: 10%; padding-top: 20px; vertical-align: top;">
                        <div style="display: flex; justify-content: center;">
                            <img src="../../../assets/images/edit.png" style="margin-right: 10px;" @click="openEditUserGroup(userGroup)" />
                            <img src="../../../assets/images/delete-icon.png" @click="removeUserGroup(userGroup.id)" />
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- User Group Add/Edit Modal -->
        <el-dialog
            :visible.sync="userGroupShowPopup"
            title="Add/Edit User Group"
            :custom-class="'user-group-update-popup'"
            top="0"
            width="95%"
            :fullscreen="true"
        >
            <el-row :gutter="20" class="my-4">
                <el-col
                    :span="12"
                >
                    <h2>Add/Edit User Group</h2>
                </el-col>
                <el-col :span="12" class="text-right">
                    <!-- <el-button icon="el-icon-close" circle size="medium" @click="userGroupShowPopup = false"></el-button> -->
                    <i class="el-icon-circle-close cursor-pointer" style="font-size: 25px;" @click="userGroupShowPopup = false"></i>
                </el-col>
            </el-row>
            <div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-row :gutter="20" class="mb-8">
                            <el-col :span="6">
                                <span class="font-bold">Group Name</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input v-model="userGroupName" placeholder="Enter Group Name" style="width: 240px;"
                                    size="small"></el-input>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" class="mb-8">
                            <el-col :span="6">
                                <span class="font-bold">Add By</span>
                            </el-col>
                            <el-col :span="18">
                                <el-select v-model="userSelectedDesignations" multiple filterable collapse-tags
                                    placeholder="Select add by" style="width: 240px;" size="small"
                                    @change="getUserByDesignations">
                                    <el-option v-for="(item, index) in allDesignations" :key="'designation-item-' + index"
                                        :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20" class="mb-8">
                            <el-col :span="6">
                                <span class="font-bold">Employees</span>
                            </el-col>
                            <el-col :span="18">
                                <el-select
                                    v-model="selectedUsers"
                                    multiple
                                    filterable
                                    collapse-tags
                                    placeholder="Select employees"
                                    style="width: 240px;"
                                    size="small"
                                    @change="handleChangeAddUser"
                                    @remove-tag="handledRemovedUser"
                                >
                                    <el-option
                                        v-for="(item, index) in userList"
                                        :key="'user-item-' + index"
                                        :label="item.full_name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="12"></el-col>
                </el-row>
                <div v-if="selectedUsers.length">
                    <el-row :gutter="20" class="mt-3 py-2"
                        style="background: #F2F2F2; color: #707070; font-weight: 700; font-size: 15px;">
                        <el-col :span="4">
                            EMPLOYEE NAME
                        </el-col>
                        <el-col :span="3">
                            DESIGNATION
                        </el-col>
                        <el-col :span="4">
                            ACCESS LEVEL
                        </el-col>
                        <el-col :span="3">
                            REGION
                        </el-col>
                        <el-col :span="3">
                            SUB REGION
                        </el-col>
                        <el-col :span="3">
                            OUTLET
                        </el-col>
                        <el-col :span="4">
                            &nbsp;
                        </el-col>
                    </el-row>
                    <div style="height: 300px; overflow-y: auto; padding: 10px; text-transform: capitalize;">
                        <el-row v-for="(userGroupItem, userGroupItemIndex) in selectedUsers" :key="userGroupItemIndex"
                            :gutter="20" class="py-4" style="font-size: 15px; border-bottom: 1px solid #e6e6e6;">
                            <el-col :span="4">
                                {{ selectedUserName(userGroupItem) }}
                            </el-col>
                            <el-col :span="3">
                                {{ selectedDesignationName(userGroupItem) }}
                            </el-col>
                            <el-col :span="4">
                                {{ selectedUserAccessLevel(userGroupItem) | removeDashes }}
                            </el-col>
                            <el-col :span="3">
                              {{ selectedRegions(userGroupItem) }}
                            </el-col>
                            <el-col :span="3">
                              {{ selectedSubRegions(userGroupItem) }}
                            </el-col>
                            <el-col :span="3">
                              {{ selectedOutletName(userGroupItem) }}
                            </el-col>
                            <el-col :span="4">
                                <span>
                                    <img src="../../../assets/images/delete-icon.png" @click="handleDeleteUserFromUserGroup(userGroupItem)" />
                                </span>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="20" class="mt-12">
                        <el-col :span="24" class="text-right">
                            <el-button type="warning" @click="addNewUserGroup">Update</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ticketsService from '../../../services/ticketsService';
import { EventBus } from "../../../eventBus";
export default {
    name: "UserGroups",
    filters: {
        removeDashes(val) {
            if (val) {
                return val.replace(/_/g, ' ');
            } else {
                return '-';
            }
        }
    },
    data() {
        return {
            userGroupList: [],
            active_user_group_id: "",
            userGroupDetails: [],
            isLoading: false,
            userGroupShowPopup: false,
            allDesignations: [],
            userGroupName: "",
            userSelectedDesignations: [],
            userList: [],
            selectedUsers: [],
            selectedUserGroup: {},
            removedUserList: [],
            addedUserList: [],
        };
    },
    watch: {
        userGroupShowPopup(newVal, oldVal) {
            if(newVal === false) {
                this.active_user_group_id = "";
                this.userGroupDetails = [];
                this.userGroupName = "";
                this.userSelectedDesignations = [];
                this.selectedUsers = [];
                this.userList = [];
                this.selectedUserGroup = {};
                this.removedUserList = [];
                this.addedUserList = [];
            }
        }
    },
    mounted() {
        const self = this;
        this.getAllUserTypes();
        this.getAllUserDesignations();
        EventBus.$on("openNewUserGroup", function () {
            self.openCreateEditUserGroup();
        });
    },
    methods: {
        handleDeleteUserFromUserGroup(id) {
            this.$confirm(`Do you wish to delete this user?`, "Alert", {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                dangerouslyUseHTMLString: true
            }).then(() => {
                this.removeSelectedUser(id);
                this.handledRemovedUser(id);
            })
            .catch(() => {

            });
        },
        removeSelectedUser(id) {
            let check = this.selectedUsers.findIndex(el => el == id);
            if(check !== -1) {
                this.$delete(this.selectedUsers, check);
            }
        },
        selectedUserName(val) {
            if (val) {
                let check = this.userList.find(el => el.id == val);
                if (check && check.full_name) {
                    return check.full_name;
                } else {
                    return "-";
                }
            } else {
                return "-";
            }
        },
        selectedUserAccessLevel(val) {
            if (val) {
                let check = this.userGroupDetails.find(el => el.id == val);
                if (check && check.access_level) {
                    return check.access_level;
                } else {
                    return "-";
                }
            } else {
                return "-";
            }
        },
        selectedRegions(val) {
					if (val) {
                let check = this.userGroupDetails.find(el => el.id == val);
                if (check && check.access_region_info && check.access_region_info.length) {
                    return check.access_region_info.map(el => el.name).join(', ');
                } else {
                    return "-";
                }
            } else {
                return "-";
            }
        },
        selectedSubRegions(val) {
					if (val) {
                let check = this.userGroupDetails.find(el => el.id == val);
                if (check && check.access_subregion_info && check.access_subregion_info.length) {
                    return check.access_subregion_info.map(el => el.name).join(', ');
                } else {
                    return "-";
                }
            } else {
                return "-";
            }
        },
        selectedOutletName(val) {
					if (val) {
                let check = this.userGroupDetails.find(el => el.id == val);
                if (check && check.access_outlet_name) {
                    return check.access_outlet_name;
                } else {
                    return "-";
                }
            } else {
                return "-";
            }
        },
        selectedDesignationName(val) {
            if (val) {
                let check = this.userGroupDetails.find(el => el.id == val);
                if (check && check.designation_info && check.designation_info.name) {
                    return check.designation_info.name;
                } else {
                    return "-";
                }
            } else {
                return "-";
            }
        },
        async getAllUserTypes() {
            this.isLoading = true;
            await ticketsService.getAllUserGroups()
                .then(response => {
                    const responseData = JSON.parse(response.data);
                    // let localUserGroups = responseData.map(el => ({
                    //     ...el,
                    //     collapse: false,
                    // }));
                    // if (localUserGroups && localUserGroups.length && localUserGroups[0]) {
                    //     localUserGroups[0].collapse = true;
                    // }
                    // this.userGroupList = [...localUserGroups];
                    // this.active_user_group_id = responseData[0].id;
                    // this.getUserGroupDetails(responseData[0].id);
                    this.userGroupList = [...responseData];
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(res => {
                    this.isLoading = false;
                });
        },
        async getUserGroupDetails(item) {
            if (item) {
                this.isLoading = true;
                const payload = {
                    user_group: item
                }
                await ticketsService.getUserGroupUsers(payload)
                    .then(res => {
                        this.userGroupDetails = JSON.parse(res.data).data;
                    })
                    .catch(err => {
                        console.error(err);
                    })
                    .finally(result => {
                        this.isLoading = false;
                    });
            }
        },
        handleUserDetailsGroupList(userIndex, userToggle) {
            if (userToggle === false) {
                this.userGroupList = this.userGroupList.map(el => ({
                    ...el,
                    collapse: false
                }));
                this.userGroupDetails = [];
            } else if (userToggle === true) {
                this.userGroupList = this.userGroupList.map(el => ({
                    ...el,
                    collapse: false
                }));
                this.userGroupList[userIndex].collapse = true;
                this.getUserGroupDetails(this.userGroupList[userIndex].id);
            }
        },
        openCreateEditUserGroup() {
            this.userGroupShowPopup = true;
        },
        getAllUserDesignations() {
            ticketsService.getAllUserDesignations()
                .then(res => {
                    this.allDesignations = JSON.parse(res.data);
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        async getUserByDesignations() {
            let params = {
                designations: this.userSelectedDesignations
            }
            await ticketsService.getUserByDesignaion(params)
                .then(response => {
                    this.userList = JSON.parse(response.data).data;
                })
                .catch(error => {
                    console.error(error);
                });
        },
        async addNewUserGroup() {
            if(this.selectedUserGroup.id) {
                if(this.selectedUserGroup.name != this.userGroupName) {
                    const params = {
                        name: this.userGroupName
                    }
                    await ticketsService.updateUserGroupDetails(this.selectedUserGroup.id, params)
                    .then(response => {
                        // do nothing
                    })
                    .catch(error => {
                        console.error(error);
                    });
                }
                if(this.removedUserList && this.removedUserList.length) {
                    const params = {
                        user_group: this.selectedUserGroup.id,
                        users: [...this.removedUserList]
                    };
                    ticketsService.removeUsersFromUserGroup(params)
                    .then(res => {
                        // do nothing
                    })
                    .catch(error => {
                        console.error(error);
                    });
                }
                if(this.addedUserList && this.addedUserList.length) {
                    const params = {
                        user_group: this.selectedUserGroup.id,
                        users: this.addedUserList
                    };
                    await ticketsService.addUsersToUserGroup(params)
                    .then(response => {
                        // console.log(JSON.parse(response.data));
                    })
                    .catch((error) => {
                        console.error(error);
                    });
                }
                this.userGroupShowPopup = false;
                await this.getAllUserTypes();
            } else {
                const params = {
                    name: this.userGroupName
                }
                ticketsService.addNewUserGroup(params)
                    .then(response => {
                        const responseData = JSON.parse(response.data);
                        if (responseData.id) {
                            this.addUsersToGroup(responseData.id);
                            this.userGroupShowPopup = false;
                            this.getAllUserTypes();
                        }
                    })
                    .catch(error => {
                        console.error(error.response.data);
                        if (error.response.data) {
                            const responseData = JSON.parse(error.response.data);
                            if (responseData.msg) {
                                this.$notify.error({
                                    title: "Failed",
                                    message: responseData.msg
                                });
                            }
                        }
                    });
            }

            this.addedUserList = [];
            this.removedUserList = [];
            this.selectedUserGroup = {}
            this.selectedUsers = [];
            this.userSelectedDesignations = [];
        },
        addUsersToGroup(groupId) {
            const params = {
                user_group: groupId,
                users: this.selectedUsers
            };
            ticketsService.addUsersToUserGroup(params)
                .then(response => {
                    // console.log(JSON.parse(response.data));
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        removeUserGroup(group_id) {
            const self = this;
            this.$confirm(`Do you really want to delete this group?`, 'Alert!', {
				confirmButtonText: 'Confirm',
				dangerouslyUseHTMLString: true
			}).then(() => {
                ticketsService.deleteUserGroup(group_id)
                .then(response => {
                    self.getAllUserTypes();
                })
                .catch(error => {
                    console.error(error);
                });
            }).catch(error => console.error(error));
        },
        async openEditUserGroup(userGroup) {
            this.selectedUserGroup = {...userGroup};
            if(this.selectedUserGroup.name) {
                this.userGroupName = this.selectedUserGroup.name;
                this.userSelectedDesignations = this.allDesignations.map(el => el.id);
                await this.getUserByDesignations();
                await this.getUserGroupDetails(userGroup.id);
                this.selectedUsers = this.userGroupDetails.map(el => el.id);
                this.userGroupShowPopup = true;
            }
        },
        handledRemovedUser(event) {
            let check = this.removedUserList.find(el => el == event);
            if(check === undefined) {
                this.removedUserList.push(event);
            }
        },
        handleChangeAddUser(event) {
            if(event && event.length && this.userGroupDetails && this.userGroupDetails.length) {
                let oldUserList = this.userGroupDetails.map(el => el.id);
                this.addedUserList = event.filter(el => !oldUserList.includes(el));
            }
        }
    }
}
</script>

<style lang="scss">
.user-groups {
    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        text-transform: capitalize;
    }

    thead th {
        height: 40px;
        color: #707070;
        background-color: #f2f2f2 !important;
        text-transform: uppercase;
    }

    tbody td,
    thead th {
        padding: 5px 40px;
        font-size: 13px;
    }

    td {
        text-align: center;

        img {
            width: 18px;
            cursor: pointer;
        }
    }

    td:first-child,
    th:first-child {
        text-align: left;
    }

    .title {
        color: #7ea9f8;
        font-size: 0.9rem;
        font-weight: bold;
        cursor: pointer;
    }

    .toggle-icon {
        color: #e29d5a;
        font-size: 15px;
        cursor: pointer;
    }

    /* .title {
        color: #e29d5a;
        font-size: 15px;
    } */

    .user-group-update-popup {
        position: absolute;
        right: 0;
        width: 95% !important;
        .el-dialog__header {
            display: none;
        }
    }
}
</style>
